import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';


export interface IForwardIconProps extends ISvgIconProps {

}

export class ForwardIcon extends React.Component<IForwardIconProps, {}> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g transform="rotate(180) translate(-24 -24)">
                    <path
                        fill="currentColor"
                        d="M14.18,20.36a2,2,0,0,1-1.41-.58L6.4,13.41a2,2,0,0,1,0-2.82l6.37-6.37A2,2,0,0,1,15.6,7.05l-4.95,5L15.6,17a2,2,0,0,1-1.42,3.41Z"
                    />
                </g>
            </SvgIcon>
        );
    }
}
